"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSerializedUserData = exports.initiateLogin = exports.submitLoginForm = void 0;
const auth_1 = require("../auth");
const validation_1 = require("../ibl-web/validation");
function submitLoginForm(callback = null) {
    const inputs = document.querySelectorAll('input[form-type="signin"]');
    let isValidForm = true;
    let errorMsg = '';
    for (let input of Array.from(inputs)) {
        const inputValue = input.value;
        const inputName = input.getAttribute('name');
        if (!inputValue) {
            let label;
            if (inputName == 'password') {
                label = 'Password';
            }
            if (inputName == 'email_or_username') {
                label = 'Email or Username';
            }
            errorMsg = `${label} is required.`;
            if (callback) {
                callback(errorMsg, input);
            }
            else {
                (0, validation_1.renderSpanElement)(errorMsg, input);
            }
            isValidForm = false;
        }
        else {
            if (callback) {
                callback(null, input);
            }
            else {
                (0, validation_1.renderSpanElement)(null, input);
            }
        }
    }
    if (isValidForm === true) {
        initiateLogin();
    }
}
exports.submitLoginForm = submitLoginForm;
function initiateLogin() {
    const emailOrUsername = (document.querySelector('input[name="email_or_username"]')).value;
    const password = (document.querySelector('input[name="password"]')).value;
    const _auth = new auth_1.default();
    _auth.login(emailOrUsername, password, function (userData) {
        localStorage.setItem('token', userData.token);
        localStorage.setItem('IBL_AXD_URL', userData.ibl_axd_url);
        localStorage.setItem('IBL_WEB_URL', userData.ibl_web_url);
        localStorage.setItem('IBL_EDX_URL', userData.ibl_edx_url);
        localStorage.setItem('IBL_SEARCH_URL', userData.ibl_search_url);
        localStorage.setItem('userData', JSON.stringify(userData));
        window.location.href = window.location.origin;
    });
}
exports.initiateLogin = initiateLogin;
function getSerializedUserData() {
    return JSON.parse(localStorage.getItem('userData'));
}
exports.getSerializedUserData = getSerializedUserData;
